import { observable, extendObservable } from "mobx";
import { formatarCPF } from "../../../utils/functions";
import moment from "moment/moment";
import _ from "lodash";
import {
    CargoService,
    EmpresaGloboService,
    MOTService
} from "../../../services";

export default class HistoricoContratacaoFiltroStore {
    @observable exportOpen;

    @observable cargos = [];
    @observable empresas = [];
    @observable dataInicialSelecionada;
    @observable cpfSelecionado;
    @observable solicitacaoExcecaoSelecionada;

    @observable cargosValidacao;
    @observable empresasValidacao;
    @observable dataInicialValidacao;
    @observable dataFinalValidacao;
    @observable propostaSalarioValidacao;
    @observable motSelecionado;
    @observable inputValue = '';
    @observable buscandoMOT = false;

    constructor(dataInicialFiltroValue) {
        this.cargoService = new CargoService();
        this.empresaGloboService = new EmpresaGloboService();
        this.motService = new MOTService();

        if (dataInicialFiltroValue) {
            this.dataInicialValidacao = moment(dataInicialFiltroValue).format("DD/MM/YYYY");
            this.dataInicialSelecionada = dataInicialFiltroValue;
        }
        this.filtro = {};

    }

    carregarListas = (params, fields) => {
        extendObservable(this.filtro, params);

        this.carregarCargos();
        this.carregarEmpresas();
        this.carregarDataInicial();
        this.carregarCPF();
        //this.carregarSolicitacaoExcecao();

    }

    carregarCargos = () => {
        this.cargosValidacao = this.filtro.cargos;

        this.cargoService.listFromBase().then(response => {
            let cargos = response.data
                .filter(cargo => cargo)
                .map(cargo => ({
                    value: cargo.id,
                    label: cargo.nome + " (" + cargo.id + ")",
                    name: cargo.nome
                }));

            this.cargos = _.orderBy(cargos, ["label"], ["asc"]);
        }).catch(error => {
            this.erro = error;
        });
    }

    carregarEmpresas = () => {
        this.empresasValidacao = this.filtro.empresas;

        this.empresaGloboService.list().then(response => {
            let empresas = response.data
                .filter(empresa => empresa)
                .map(empresa => ({
                    value: empresa.id,
                    label: empresa.nome
                }));

            this.empresas = _.orderBy(empresas, ["label"], ["asc"]);
        }).catch(error => {
            this.erro = error;
        });
    }

    carregarDataInicial = () => {
        if (this.filtro.dataInicial) {
            this.dataInicialValidacao = moment(this.filtro.dataInicial).format("DD/MM/YYYY");
            this.dataInicialSelecionada = moment(this.filtro.dataInicial, "YYYY-MM-DD");
        }
    }

    carregarCPF = () => {
        this.cpfSelecionado = this.filtro.cpf;
    }

    setCargo = (value) => {

        if (value && value != null) {

            const cargo = this.cargos.find(cargo => (cargo.value == value));

            this.filtro.cargoId = cargo.value;
            this.filtro.nomeCargo = cargo.name;
        } else {
            this.filtro.cargoId = null;
            this.filtro.nomeCargo = null;

        }
        this.cargosValidacao = value;
    }

    setEmpresa = (value) => {
        this.filtro.empresaGloboId = value;
        this.empresasValidacao = value;
    }

    setDataInicial = (value) => {
        if (!moment(value).isValid()) {
            this.dataInicialValidacao = null;
            this.dataInicialSelecionada = null;
            this.filtro.dataInicioContrato = null;
            return;
        }

        this.dataInicialValidacao = moment(value).format("DD/MM/YYYY");
        this.dataInicialSelecionada = moment(value, "DD-MM-YYYY");
        this.filtro.dataInicioContrato = moment(value).format("DD/MM/YYYY");
    }

    setDataInicialCheck = (value) => {
        this.dataInicialValidacao = value;
    }

    setCPF = (value) => {
        this.filtro.cpf = value;
        this.cpfSelecionado = value;
    }

    setNomeMot = (value) => {
        this.filtro.nomeMot = value;
    }

    setMOTs = (value, options) => {
        if (value) {
            this.filtro.mots = (this.filtro.mots ? this.filtro.mots + "," : "") + _.last(options).id;
            this.motSelecionado = value;
            this.setCPF(_.last(options).cpf);
        } else {
            this.filtro.mots = "";
            this.motSelecionado = "";
            this.setCPF(null);
        }
    }
    setPropostaSalario = (value) => {
        this.filtro.propostaSalario = value;
        this.propostaSalarioValidacao = value;
    }

    toggleExport = () => {
        this.exportOpen = !this.exportOpen;
    }

    getFiltro = () => {
        //const filtro = { ...}

        return _.pickBy(this.filtro, _.identity);
    }

    limparFiltro = (fields) => {
        this.filtro = {};

        this.setCargo(null);
        this.setEmpresa(null);
        this.setDataInicial(null) && setDataInicialCheck(null);
        this.setCPF(null);
        this.setPropostaSalario(null);
        this.setNomeMot(null);
        this.setMOTs(null);
        this.erro = null;

    }

    filtrarMOTs = (input, callback) => {
        if (!(input && input.length > 1)) {
            callback(null, { options: [], complete: false });
            return;
        }
        console.log('LOG: antes '+input);
        this.logDebounce(input);

        this.motService.listByPrefixoNome(input).then(response => {
            let mots = response.data
                .filter(mot => mot)
                .map(mot => ({
                    id: mot.id,
                    cpf: mot.cpf,
                    value: `${mot.nomeCompleto} (${formatarCPF(mot.cpf)})`,
                    label: `${mot.nomeCompleto} (${formatarCPF(mot.cpf)})`
                }));

            mots = _.orderBy(mots, ["label"], ["asc"]);
            this.buscandoMOT = false;

            callback(null, {
                options: mots,
                complete: true
            });
        }).catch(error => {
            callback(null, { options: [], complete: false });
            this.erro = error;
        });
    }

    logTeste = (input) => {
        console.log('LOG: '+input);
    }

    logDebounce = _.debounce(this.logTeste, 1000);

    filtrarMotsDebounce = _.debounce(this.filtrarMOTs, 1000);

}
